module.exports = __webpack_public_path__ + "static/media/taylor-swift-win.d158dec8.jpg";